import { EarthquakeZoneEnum } from '@e-socna/data-layer';

export const earthquakeZoneLabels = {
  [EarthquakeZoneEnum.Zero]: '0',
  [EarthquakeZoneEnum.One]: '1 - Très faible',
  [EarthquakeZoneEnum.Two]: '2 - Faible',
  [EarthquakeZoneEnum.Three]: '3 - Modérée',
  [EarthquakeZoneEnum.Four]: '4 - Moyenne',
  [EarthquakeZoneEnum.Five]: '5 - Forte',
};
